export default __webpack_public_path__ + "static/media/img16.a4031730.webp";